import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebaseFunctions';

export type SyncShippingTrackerFromEasyPostParams = {
  trackingNumber: string;
  carrierId?: string;
  force?: boolean;
};

export type ShippingTrackerUpdateFromEasyPost = {
  formatted?: string;
  components: {
    trackingNumber: string;
    carrierId: string;
    deliveryDateMs?: number;
    currentStatus?: string;
    trackingHistory?: Array<{
      timestampMs: number;
      status: string;
      location?: string;
      details?: string;
    }>;
    origin?: string;
    destination?: string;
    additionalDetails?: Record<string, unknown>;
  };
  meta?: Record<string, unknown>;
};

export async function callSyncShippingTrackerFromEasyPost(
  params: SyncShippingTrackerFromEasyPostParams
): Promise<ShippingTrackerUpdateFromEasyPost> {
  const fn = httpsCallable(functions, 'syncShippingTrackerFromEasyPost');
  const res = await fn(params);
  return res.data as ShippingTrackerUpdateFromEasyPost;
}

